import { Duration } from 'dayjs/plugin/duration.js';
import { TimeZone } from '../../time/timezone.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class ServiceDuration extends DataModel {
  static readonly TYPE_ID: string = 'fca68d7a7ee24438b66382eb1cf1ca1d';

  constructor(
    public readonly duration: Duration,
    public readonly blocking: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return ServiceDuration.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServiceDuration {
    return new ServiceDuration(
        context.decodeDuration(MapUtils.get<number>(map, 'duration')),
        MapUtils.get<boolean>(map, 'blocking'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'duration': context.encodeDuration(this.duration),
      'blocking': this.blocking,
    };
  }

  clone(): this {
    return new ServiceDuration(
        TimeZone.cloneDuration(this.duration),
        this.blocking,
    ) as this;
  }

  isSame(other: ServiceDuration): boolean {
    if(this === other) {
      return true;
    }

    return other.duration.asMilliseconds() === this.duration.asMilliseconds() &&
          other.blocking === this.blocking;
  }
}

export class ServiceDurationBuilder extends DataModelBuilder<ServiceDuration> {
  build(context: SerializationContext, map: SerializedData): ServiceDuration {
    return ServiceDuration.fromMap(context, map);
  }
}
